export default "__VITE_ASSET__D_iJY8t7__"